import ProjectFormLayout from './components/ProjectFormLayout';

export default function ProjectFormPage({ mode }) {
  return <ProjectFormLayout mode={mode} />;
}
